

export default {
  NUMBER: 'number',
  CURRENCY: 'currency',
  PERCENT: 'percent'
};
